import {FormValidationService} from './form-validation-service'
import {Validatable} from './validatable'
import {settlePromises} from './settle-promises'
import { Injectable } from "@angular/core";

@Injectable()
export class DefaultFormValidationService implements FormValidationService {
  private validatables: Validatable<any>[] = []

  subscribe(validatable: Validatable<any>) {
    this.validatables.push(validatable)
  }

  unsubscribe(validatable: Validatable<any>): void {
    this.validatables.splice(this.validatables.indexOf(validatable), 1)
  }

  validateAll(onSuccess: Function, onFailure: Function): void {
    let validationPromises: Promise<undefined>[]

    validationPromises = this.validatables.map((validatable) => {
      return validatable.runValidations()
    })

    settlePromises(validationPromises).then(() => {
      onSuccess()
    }).catch(() => {
      onFailure()
    })
  }
}
